import { useEffect, useState } from "react";
import { Stack, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import TableWrapper from "@/components/Table/TableWrapper";
import upcomingInstallmentsSchema from "@/components/Table/schemas/upcoming_installments";

import { getRepaymentSchedule } from "@/services/loanservices";

export default function UpcomingInstallments({ loanUUID }) {
  const navigate = useNavigate();
  const [installments, setInstallments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (loanUUID) fetchInstallments();
  }, [loanUUID]);

  const fetchInstallments = async () => {
    try {
      const res = await getRepaymentSchedule(loanUUID);
      const amortization =
        res?.results?.response?.data?.amortization || [];

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const mapped = amortization
        .filter((item) => {
          const emiDate = new Date(item.emiDate);
          emiDate.setHours(0, 0, 0, 0);
          return emiDate > today;
        })
        .map((item) => ({
          amount: item.installmentAmount,
          dueDate: item.emiDate,
        }));

      setInstallments(mapped);
    } catch (err) {
      console.error("Failed to fetch installments", err);
    } finally {
      setLoading(false);
    }
  };

  const displayedData = showAll
    ? installments
    : installments.slice(0, 3);

  return (
    <Card className="border-0 rounded-lg p-4">
      <Stack direction="horizontal" className="justify-between">
        <div className="text-md fw-semibold text-gray-500">
          Upcoming Installments
        </div>
        <span
          className="text-sm text-decoration-underline cursor-pointer"
          onClick={() => navigate(`/lms/${loanUUID}/loan-information`)}
        >
          View All
        </span>
      </Stack>

      <div className="mt-3">
        <TableWrapper
          columnSchema={upcomingInstallmentsSchema}
          tableData={displayedData}
          loading={loading}
        />
      </div>
    </Card>
  );
}
